import React from 'react'
import { Box, Typography } from '@mui/material'
import i18next from 'i18next'
import theme from '../../util/theme'
const DownloadProfile = () => {
    let lng = i18next.language
    const pdfFile = `/documents/profile.pdf`;
    return (
        <div>
            <Box sx={{
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
                transform: 'rotate(270deg)',
                py: 1,
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                position: 'fixed', top: '50%',
                right: { md: lng === 'en' ? '-1%' : '94%', xs: lng === 'en' ? '-12%' : '75%' },
                zIndex: 9999,
                width: '125px',
                textAlign: 'center'
            }} >
                <Typography sx={{ color: theme.palette.primary.text }}>
                    <a 
                    href={pdfFile} download={`profile.pdf`} 
                    style={{ color: theme.palette.primary.text, textDecoration: "none" }} >
                        {lng === 'en'?'Download Profile':"تحميل البروفايل"}
                    </a>
                </Typography>
            </Box>
        </div>
    )
}

export default DownloadProfile